// extracted by mini-css-extract-plugin
module.exports = {"groupTag":"groupFilterTag_groupTag__2iPVT"};